import {StyledIconContainer} from '@components/ui/icon-container/style.ts'
import {FC, ReactNode} from 'react'

interface IconContainerProps {
    children: ReactNode
    size?: 'md' | 'lg'
    variant?: 'neutral' | 'primary'
}
export const IconContainer: FC<IconContainerProps> = ({children, size = 'md', variant = 'neutral'}) => {
    return (
        <StyledIconContainer $size={size} $variant={variant}>
            {children}
        </StyledIconContainer>
    )
}

IconContainer.displayName = 'IconContainer'
